import type {
  ConnectionEntry,
  ConnectionsListener,
} from "./connections-store.types";

export type { ConnectionEntry } from "./connections-store.types";
export { ReadyStateLabel } from "./connections-store.types";

const EMPTY_CONNECTIONS: ConnectionEntry[] = [];

export function subscribeConnectionsStore(
  listener: ConnectionsListener,
): () => void {
  void listener;
  return () => undefined;
}

export function getConnections(): ConnectionEntry[] {
  return EMPTY_CONNECTIONS;
}

export function getServerSnapshotConnections(): ConnectionEntry[] {
  return EMPTY_CONNECTIONS;
}

export function clearClosedConnections(): void {
  // Connections require explicit safe metadata registration.
}

export function initEventSourceTracker(): void {
  // Global EventSource and WebSocket interception is intentionally disabled.
}

export function initConnectionTrackers(): void {
  // Global EventSource and WebSocket interception is intentionally disabled.
}
